import {connect} from 'react-redux';

import Sport from '../Sport.jsx';

function select(state, props) {
    const sport = state.application.getIn(['menu', 'sports', props.sportId]);
    const leagues = state.application.getIn(['menu', 'leagues']);

    return {
        ...props,
        sport,
        leagues
    };
}

export default connect(select, null, null, false)(Sport);


// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/preMatch/Sport.jsx